import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTUREPAYSLIP,
    RETRIEVE_ARCHITECTUREPAYSLIP,
    RETRIEVESINGLE_ARCHITECTUREPAYSLIP,
    UPDATE_ARCHITECTUREPAYSLIP,
    DELETE_ARCHITECTUREPAYSLIP,
} from "./type";
import ARCPayslip from "../service/arcPayslip";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCPayslip.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCPayslip.create(data);
        dispatch({
            type: CREATE_ARCHITECTUREPAYSLIP,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCPayslip.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTUREPAYSLIP,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCPayslip.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTUREPAYSLIP,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCPayslip.update(data);
        dispatch({
            type: UPDATE_ARCHITECTUREPAYSLIP,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCPayslip.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTUREPAYSLIP,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCPayslip.trash(data);
        dispatch({
            type: DELETE_ARCHITECTUREPAYSLIP,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};